import FetchSpinner from "@components/global/FetchSpinner/FetchSpinner"
import * as styles from "./Spinner.module.scss"

const Spinner = (props) => {
  

  return props.active ? (
    <div className={styles.Spinner}>
      <div className={styles.SpinnerText}>
        <FetchSpinner/>
      </div>
    </div>
  ) : (
    <div />
  )
}

export default Spinner
